export enum PromotionalCodeType {
  PUBLIC = 'PUBLIC',
  REGISTRATION = 'REGISTRATION',
  BIRTH_DAY = 'BIRTH_DAY',
}
